'use client'

import { FilterBase } from '@component/searchFilter'
import useAgentListContext from '../../context'
import { useCallback, useMemo } from 'react'
import { getFilterParams } from '../../utils'
import useFetch from '@hooks/useFetch'
import { find, get, map } from 'lodash-es'
import { AgentListFilterContext, AgentListFilterState } from './context'
import { AGENT_FILTER } from '@homeSearch/modules/filter/config'
import { queryToStr } from '@plugin/searchRoute/utils'
import useProgressRouter from '@hooks/useProgressRouter'
import { agentList } from '@router'
import getAgentRoute from '@plugin/searchRoute/modules/agent'
import { SortBy } from '@component/searchFilter'
import { ORDER_AGENT } from '@config'

export default function AgentListFilter() {

  const { slug, filter, typeId, searchType } = useAgentListContext()
  const params = useMemo(() => getFilterParams(slug, filter, typeId), [slug, filter, typeId])

  const { data } = useFetch({ url: AGENT_FILTER.url, params })
  const state = AgentListFilterState()

  const { replaceRouter } = useProgressRouter()
  const confirmHandle = useCallback(filter => {
    const agentRoute = getAgentRoute()
    agentRoute.fromSlug(slug)
    agentRoute.page = 1
    const route = agentList(get(searchType, 'route'), agentRoute.toSlug(), queryToStr(filter))
    replaceRouter(route)
  }, [searchType, slug, replaceRouter])

  const order = useMemo(() => {
    const agentRoute = getAgentRoute()
    agentRoute.fromSlug(slug)
    const order = agentRoute.order || null
    return find(ORDER_AGENT, item => item.value === order)
  }, [slug])
  const orderChange = useCallback(order => {
    const agentRoute = getAgentRoute()
    agentRoute.fromSlug(slug)
    agentRoute.order = order.value
    const newSlug = agentRoute.toSlug()
    replaceRouter(agentList(get(searchType, 'route'), newSlug, filter))
  }, [filter, searchType, slug, replaceRouter])

  return data && (
    <AgentListFilterContext.Provider value={state}>
      <div className='flex flex-wrap md:flex-nowrap gap-8'>
        {
          map(data, item => (
            <FilterBase key={item.alias} data={item} params={params} confirmLabel='Show {totals} agents' onConfirm={confirmHandle}>{item.label}</FilterBase>
          ))
        }
        <SortBy data={ORDER_AGENT} value={order} onChange={orderChange} className='sm:ml-auto'></SortBy>
      </div>
    </AgentListFilterContext.Provider>
  )
}
